<div class="quick-search" [class.expanded]="expanded()" #origin="matAutocompleteOrigin" matAutocompleteOrigin>
  <mat-form-field
    appearance="outline"
    class="no-subscript"
    (transitionstart)="onTransitionStart($event)"
    (transitionend)="onTransitionEnd($event)"
  >
    <input
      matInput
      #input
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [tabIndex]="expanded() ? 0 : -1"
      [placeholder]="'SEARCH.FIELD_QUICK_SEARCH' | translate"
      [ngModel]="searchString$ | async"
      (ngModelChange)="onInput($event)"
      #trigger="matAutocompleteTrigger"
      (keydown.enter)="onEnter(trigger)"
      [matAutocomplete]="fulltextAutocompletePanel"
      [matAutocompleteConnectedTo]="origin"
      (blur)="onInputBlur($event)"
    />
    <!-- [panelHeight]="600" -->
    <!-- autocompleteCustomizer -->
    <mat-icon matPrefix class="search-prefix-icon" aria-hidden="true">search</mat-icon>
    <div class="field-actions" matSuffix>
      @if (expanded() && !(isEmpty$ | async)) {
        <button matIconButton type="button" [tabIndex]="-1" (click)="onClear()">
          <mat-icon>close</mat-icon>
        </button>
      }
      <button matButton="filled" type="button" class="search-btn" (click)="onSearchClick($event)">
        {{ "SEARCH.BTN_SEARCH" | translate }}
      </button>
    </div>
    <mat-autocomplete
      #fulltextAutocompletePanel="matAutocomplete"
      class="high-autocomplete force-light-theme"
      autoActiveFirstOption="false"
    >
      @if (isEmpty$ | async) {
        <mat-option [disabled]="true">
          {{ "SEARCH.TYPE_TO_SEARCH" | translate }}
        </mat-option>
      } @else {
        <div class="sticky-top">
          <mat-option class="more-results" (click)="onEnter()">
            {{ "SEARCH_RESULTS.DETAILED_SEARCH" | translate }}
          </mat-option>
        </div>

        <mat-option [disabled]="true" class="placeholder-option" />
        @let results = fulltextAutocompletePanel.isOpen ? (searchResults$ | async) : null;
        @if (loading()) {
          <mat-option [disabled]="true">
            <div class="u-center">
              <mat-spinner mode="indeterminate" [diameter]="24" />
            </div>
          </mat-option>
        } @else {
          @if (results?.entries?.length === 0) {
            <mat-option [disabled]="true">
              <div class="u-center">
                <mat-icon>highlight_off</mat-icon>
                {{ "SEARCH_RESULTS.NO_RESULTS" | translate }}
              </div>
            </mat-option>
          } @else {
            @for (item of results?.entries; track item.id) {
              @if (item | itemLink; as link) {
                <mat-option [attr.data-link]="link | json">
                  @if (item | itemLink: (searchString$ | async); as link) {
                    <a class="result-item" queryParamsHandling="merge" [routerLink]="link.routerLink" [queryParams]="link.queryParams"
                      ><app-search-result [result]="item" [search]="searchString$ | async" />
                    </a>
                  }
                </mat-option>
              }
            }
          }
        }
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
